import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useCaseBanner = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'b2' as const,
        topicTitle: 'b4' as const,
      },
      791: {
        title: 'b3' as const,
        topicTitle: 'b3' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const responsiveSizes = {
    1440: {
      height: 280,
      width: 480,
    },
    1280: {
      height: 280,
      width: 300,
    },
    791: {
      height: 200,
      width: 200,
    },
    480: {
      height: 105,
      width: 320,
    },
  }

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 791) return fontSizesByScreenSize[791]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
    responsiveSizes,
  }
}
